import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=50371d2c&scoped=true&lang=html&"
import script from "./SectionHeader.vue?vue&type=script&lang=js&"
export * from "./SectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=50371d2c&lang=scss&scoped=true&"
import style1 from "./SectionHeader.vue?vue&type=style&index=1&id=50371d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50371d2c",
  null
  
)

export default component.exports